export default "__VITE_ASSET__BEBmjleY__"